import React from 'react';

import BoxLayout from 'sharedreact/components/BoxLayout';

type Props = {
  children: React.ReactNode,
};

class Statusbar extends React.PureComponent<Props> {
  override render (): React.ReactNode {
    const { children } = this.props;

    return (
      <div className='esko_statusbar'>
        <BoxLayout horizontal className='esko_container'>
          {children}
        </BoxLayout>
      </div>
    );
  }
}

export default Statusbar;
